import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

export const measurementsSlice = createSlice({
  name: "measurements",
  initialState,
  reducers: {
    addMeasurement: (state, action) => {
      return { ...state, ...action.payload };
    },
    removeMeasurement: (state, action) => {
      const { type, index, actualIdentifier = null } = action.payload;
      const identifier = actualIdentifier || `element-${type}-${index}`;
      if (type === "sinks") {
        const holeIdentifier1 = `element-${type}-${index}-hole-1`;
        const holeIdentifier3 = `element-${type}-${index}-hole-3`;
        const holeGapSink = `element-${type}-${index}-holeGapSink`;

        delete state[holeIdentifier1];
        delete state[holeIdentifier3];
        delete state[holeGapSink];
      }
      if (type === "holes") {
        const holeGapSink = `element-${type}-${index}-holeGapSink`;

        delete state[holeGapSink];
      }
      delete state[identifier];
    },
  },
});

/** Actions */
export const { addMeasurement, removeMeasurement } = measurementsSlice.actions;

/** Selectors */
export const getMeasurementCoordinates = (store) => store.measurements;
